import { get } from '@kit/utils/APIV1.js'

export const contactPage = async() => {
  return get(`contact-page/id/895`)
}
